import { render, staticRenderFns } from "./FormElectricity.vue?vue&type=template&id=c35fca58&"
import script from "./FormElectricity.vue?vue&type=script&lang=js&"
export * from "./FormElectricity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports